import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  error: '',
  loading: false,
  token: '',
  id_token: '',
  tokenExpire: null,
  expired: null,
  scopes: []
};

export const setAuthInfo =
  ({ access_token, id_token, expired, expires_at, scopes }) =>
  async (dispatch, getState) => {
    const authInfo = {
      token: access_token,
      id_token,
      tokenExpire: expires_at,
      expired,
      scopes
    };

    return dispatch(setAuthInfos(authInfo));
  };

const loginSlice = createSlice({
  name: 'auth/login',
  initialState,
  reducers: {
    setAuthInfos: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    loginError: (state, action) => {
      state.error = true;
      state.loading = false;
    },
    rememberCredentials: (state, action) => {
      state.loginCredentials = action.payload;
    },
    passwordMustChanged: (state, action) => {
      state.passwordMustChange = action.payload;
    }
  },
  extraReducers: {}
});

export const { setAuthInfos, loginError, rememberCredentials, passwordMustChanged } =
  loginSlice.actions;

export default loginSlice.reducer;
